import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const SummaryChartsDataContext = createContext();

const SummaryChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.REGISTERS_MAPPING,
            url: 'governanceroom/esus/production/resume'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );


    const chartData = data
        ? {
              indicators: {
                  identificationIndex:
                      data?.indicators?.identificationIndex ?? 0
              },
              totalServices: data?.totalServices ?? [],
              annualEvolutionServices: data?.annualEvolutionServices ?? [],
              annualPercentageServices: data?.annualPercentageServices ?? [],
              monthlyEvolutionServices: data?.monthlyEvolutionServices ?? []
          }
        : {
              indicators: {
                  identificationIndex: 0
              },
              totalServices: [],
              annualEvolutionServices: [],
              annualPercentageServices: [],
              monthlyEvolutionServices: []
          };

    return (
        <SummaryChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </SummaryChartsDataContext.Provider>
    );
};

export default SummaryChartsDataProvider;
